<template>
  <div
    class="overlay overlay--modal"
    :class="[
      {'is-active': active}
    ]"
    role="dialog"
    labelledby="modal-title">

    <div class="modal" :class="[modifierClass]">
      <a href="javascript:;" class="button button--with-icon js--modal-close" v-if="closeable" @click="doClickClose">
        <svg class="svg-icon svg-icon-close">
          <use xlink:href="/themes/custom/tryg/dist/svg/svg-sprite.svg#close"></use>
        </svg>
      </a>

      <div class="modal__content">
        <div class="modal__content__inner">
          <h1 class="page-header__headline" v-if="headline">
            {{headline}}
          </h1>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const uuidv4 = require('uuid/v4')

export default {
  name: 'Modal',
  props: {
    active: {
      type: Boolean,
      default: false,
      twoWay: true
    },
    show: {
      type: Boolean,
      default: false,
      twoWay: true
    },
    closeable: {
      type: Boolean,
      default: true
    },
    headline: {
      type: String,
      default: null
    },
    modifier: {
      type: String,
      default: 'small center' // ( center || small ]
    }
  },
  data: function () {
    return {
      modalClass: 'modal--',
      isActive: this.active,
      uuid: null
    }
  },
  computed: {
    modifierClass () {
      if (this.modifier.length) {
        return this.modifier.split(' ').map(m => this.modalClass + m).join(' ')
      } else {
        return ''
      }
    }
  },
  mounted () {
    this.uuid = uuidv4()
  },
  methods: {
    doClickClose () {
      if (this.closeable) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style scope>
.collapsible-content--open {
  display:block
}
.cursor-pointer {
  cursor:pointer
}
</style>



// WEBPACK FOOTER //
// src/components/common/Modal.vue